import { Button } from "@/components/ui/button";
import { ClipboardList, Activity, TrendingUp } from "lucide-react";

interface ProviderHeaderProps {
  onAssessmentClick: () => void;
  onCarePlanningClick: () => void;
  onProgressClick: () => void;
}

export const ProviderHeader = ({
  onAssessmentClick,
  onCarePlanningClick,
  onProgressClick
}: ProviderHeaderProps) => {
  return (
    <div className="flex flex-col space-y-4 sm:space-y-0 sm:flex-row justify-between items-stretch sm:items-center bg-white p-4 rounded-lg shadow-sm">
      <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-0">
        Provider Dashboard
      </h1>
      
      <div className="grid grid-cols-1 sm:flex sm:flex-row gap-4">
        <Button
          variant="outline"
          className="w-full sm:w-auto flex items-center justify-center gap-3 min-h-[44px] px-6 py-3 touch-target"
          onClick={onAssessmentClick}
        >
          <ClipboardList className="h-5 w-5" />
          <span className="whitespace-nowrap">Assessment</span>
        </Button>
        
        <Button
          variant="outline"
          className="w-full sm:w-auto flex items-center justify-center gap-3 min-h-[44px] px-6 py-3 touch-target"
          onClick={onCarePlanningClick}
        >
          <Activity className="h-5 w-5" />
          <span className="whitespace-nowrap">Care Planning</span>
        </Button>
        
        <Button
          variant="outline"
          className="w-full sm:w-auto flex items-center justify-center gap-3 min-h-[44px] px-6 py-3 touch-target"
          onClick={onProgressClick}
        >
          <TrendingUp className="h-5 w-5" />
          <span className="whitespace-nowrap">Progress</span>
        </Button>
      </div>
    </div>
  );
};